<template>
  <div class="container py-5">

    <p>
    <b>TSK 將參與 2024臺灣皮膚科醫學會第50屆年會！</b><br><br>我們的醫學美容尖針與鈍針，結合多項創新技術，為醫療專業人士提供安全、優質且令人安心的產品。展會現場將展示多款TSK針頭的型號規格，歡迎親臨攤位體驗TSK針頭的卓越手感。<br><br><b>🌟 好康加碼 1 🌟</b><br> 當天蒞臨TSK攤位，填寫摸彩券，即可參與「TSK尖針鈍針 針心針意 好運加碼抽獎活動」！有機會抽中TSK高品質尖針、鈍針等精美好禮！<br><br><b>🌟 好康加碼 2 🌟</b><br> 歡迎至TSK現場攤位參與「展會限定-幸運轉轉盤活動」贏取更多專屬優惠！<br>驚喜獎品包含產品折扣、贈品組合等多重優惠，祝您轉出好運，帶回驚喜！ <br><br>現場更多優惠與活動等您來發現，不要錯過⮕<br>展會時間：2024/11/16(六)-17(日)<br> 展會地點：台北國際會議中心<br> 攤位編號：G1、G2
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_49.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
